import { render, staticRenderFns } from "./FlashFeed.vue?vue&type=template&id=742d5888"
import script from "./FlashFeed.vue?vue&type=script&lang=js"
export * from "./FlashFeed.vue?vue&type=script&lang=js"
import style0 from "./FlashFeed.vue?vue&type=style&index=0&id=742d5888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports